module.exports = __webpack_public_path__ + "static/img/cell--bg.68eecf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/cell--bg.png
// module id = dwnd
// module chunks = 167